import React, { createContext, useState, ReactNode } from 'react';
import {defaultUser, User} from "../model/root/User";

export const AuthContext = createContext<{
    isLoggedIn: boolean;
    userId: string;
    userDni: string;
    userCognom: string;
    user: User;
    usuari: any;
    page: string;
    token: string;
    actualSite: string;
    setUsuari: (usuari: string) => void;
    setActualSite: (setSite: string) => void;
    setLoggedIn: (loggedIn: boolean) => void;
    setUserId: (loggedIn: string) => void;
    setUserDni: (loggedIn: string) => void;
    setUserCognom: (loggedIn: string) => void;
    setUserPermissos: (loggedIn: User) => void;
    setPage: (loggedIn: string) => void;
    setToken: (token: string) => void;
}>({
    isLoggedIn: false,
    usuari: {},
    userId: '',
    userDni: '',
    userCognom: '',
    page: '',
    token: '',
    user: defaultUser,
    actualSite: '',
    setActualSite: () => {},
    setUsuari: () => {},
    setLoggedIn: () => {},
    setUserId: () => {},
    setUserDni: () => {},
    setUserCognom: () => {},
    setUserPermissos: () => {},
    setPage: () => {},
    setToken: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [usuari, setUsuari] = useState<any>({});
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userId, setUserId] = useState('');
    const [userDni, setUserDni] = useState('');
    const [userCognom, setUserCognom] = useState('');
    const [user, setUserPermissos] = useState<User>(defaultUser);
    const [page, setPageName] = useState('');
    const [token, setTok] = useState('');
    const [actualSite, setActual] = useState('root');

    const setLoggedIn = (loggedIn: boolean) => {
        setIsLoggedIn(loggedIn);
    };
    const setActualSite = (site : string) => {
        setActual(site);
    };

    const setPage = (page: string) => {
        setPageName(page);
    };
    const setToken = (token: string) => {
        setTok(token);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, userId, setLoggedIn, setUserId, user, setUserPermissos,
            actualSite, setActualSite, setPage, page , setToken, token, userDni, setUserDni, userCognom, setUserCognom,
        usuari, setUsuari}}>
            {children}
        </AuthContext.Provider>
    );
};
